import {memo} from 'react'
import * as React from 'react'

import type {AgentsTreeItemSelection} from '../../AgentsSidebar.types'
import {UNAUTHORIZED_AGENTS_SELECTION_ID} from '../../AgentsSidebar.types'
import DisconnectedAgentsCounter from '../../DisconnectedAgentsCounter/DisconnectedAgentsCounter'
import UnauthorizedAgentsCounter from '../../UnauthorizedAgentsCounter/UnauthorizedAgentsCounter'

interface Props {
  item: AgentsTreeItemSelection
}

function AgentSelectionCounterComponent(props: Props) {
  const {item} = props

  const connectedCount = item.count - item.disconnectedCount

  if (item.id === UNAUTHORIZED_AGENTS_SELECTION_ID && connectedCount > 0) {
    return <UnauthorizedAgentsCounter count={connectedCount} />
  }

  return item.disconnectedCount > 0 ? (
    <DisconnectedAgentsCounter count={item.disconnectedCount} />
  ) : null
}

export const AgentSelectionCounter = memo(AgentSelectionCounterComponent)
